import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import '@fortawesome/fontawesome-free/css/all.min.css';




import { NavComp } from './components/mainComp/NavComp';
import {FooterComp} from './components/mainComp/FooterComp';
import  ECBody  from './components/BodyComp/body';
import WhoWeAre from './components/AboutUs/whoweare';
import CodeOfEthics from './components/AboutUs/codeofethics';
import OurFaculty from './components/AboutUs/ourfaculty';
import AcademicBoard from './components/AboutUs/academicboard';
import Alumni from './components/AboutUs/alumni';
import AboutOptometry from './components/AboutUs/aboutoptometry';
import OneDayWorkShop from './components/OurCourses/onedayworkshop';
import CertificateInOptician from './components/OurCourses/certificateinoptician';
import DiplomaInOptometry from './components/OurCourses/diplomainoptometry';
import FellowshipCourse from './components/OurCourses/fellowshipcourse';
import Gallery from './components/GalleryComp/gallery';
import NewsAndEvents  from './components/NewsAndEvents/newsandevents';
import WorldSightDayOld from './components/NewsAndEvents/worldsightday23';
import WorldSightDay from './components/NewsAndEvents/worldsightday24';
import ChristmasGetTogether from './components/NewsAndEvents/christmasgettogether';
import Awurudu from './components/NewsAndEvents/awurudu';
import Cricket from './components/NewsAndEvents/cricket';
import AnnualMeeting from './components/NewsAndEvents/annualmeeting';
import ContactUs from './components/ContactUs/contactus';
import CourseRegistration from './components/OurCourses/courseregistration';
import ShortTermCourseRegistration from './components/OurCourses/shorttermcourseregistration';
import DigitalLibrary from './components/LibraryComp/digitallibrary';
import 'bootstrap/dist/css/bootstrap.min.css';
// import AwuruduSeason from './components/awurudu/awurudu';
import FindYourOptomerist from './components/FindOptometrist/findyouroptomerist';
import Download from './components/DownloadComp/download';

import AdminPanel from './components/AdminComp/adminpanel';
import PrivateRoute from './Utils/PrivateRoute';
import SignIn from './components/LoginComp/signin';
import SignUp from './components/LoginComp/signup';
import ForgotPassword from "./components/LoginComp/ForgotPassword";
import UserProfile from './components/UserComp/userprofile';
import ViewApplication   from './components/UserComp/viewapplication';
import ViewPayment from './components/UserComp/viewpayment';
import EyecareCareer from './components/CareerComp/eyecarecareer';
import CareerApply from './components/CareerComp/careerapply';
import Verification from './components/VerificationComp/verification';
import CareerGuidance from './components/NewsAndEvents/careerguidance25';
import HigherDiplomaInOptometry from './components/OurCourses/higherdiplomainoptometry';

import Test from './components/OurCourses/registration-course';

import Account from './components/AccountComp/accountpanel';

import LoadingScreen from './components/LoadingComp/LoadingScreen';

import OrientationProgramme from './components/NewsAndEvents/orientation-programme-2025';

// import Popup from './components/BodyComp/popup';

import SubAdminPanel from './components/AdminComp/sub-adminpanel';


import Ourcourses from './components/OurCourses/ourcourses';
import WorldSightDay25 from './components/NewsAndEvents/worldsightday25';

// import Snow from './components/SnowFlake/snow';
import OphthalmicOptician from './components/OurCourses/ophthalmicoptician';
import ScrollToTop from './ScrollComp/ScrollToTop';

export const App = () => {


    const [isLoading, setIsLoading] = useState(true);
  const [hasShownLoading, setHasShownLoading] = useState(false);

  useEffect(() => {
    // Check if loading screen has been shown before (using sessionStorage)
    const loadingShown = sessionStorage.getItem('loadingShown');
    
    if (loadingShown) {
      setHasShownLoading(true);
      setIsLoading(false);
      return;
    }

    // Show loading screen for 3 seconds minimum
    const timer = setTimeout(() => {
      setIsLoading(false);
      sessionStorage.setItem('loadingShown', 'true');
    }, 3000);

    // Also hide when page is fully loaded
    window.addEventListener('load', () => {
      clearTimeout(timer);
      setIsLoading(false);
      sessionStorage.setItem('loadingShown', 'true');
    });

    return () => {
      clearTimeout(timer);
      window.removeEventListener('load', () => {});
    };
  }, []);





  return (
    <Router>
        <ScrollToTop />
        {isLoading && !hasShownLoading && <LoadingScreen />}
      <NavComp />
      <Routes>
        <Route path="/" element={<ECBody />} />
        <Route path="/whoweare" element={<WhoWeAre />} />
        <Route path="/codeofethics" element={<CodeOfEthics />} />
        <Route path="/academicboard" element={<AcademicBoard />} />
        <Route path="/ourfaculty" element={<OurFaculty />} />
        <Route path="/alumni" element={<Alumni />} />
        <Route path="/aboutoptometry" element={<AboutOptometry />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/onedayworkShop" element={<OneDayWorkShop />} />
        <Route path="/certificateinoptician" element={<CertificateInOptician />} />
        <Route path="/diplomainoptometry" element={<DiplomaInOptometry />} />
        <Route path="/fellowshipcourse" element={<FellowshipCourse />} />
        <Route path="/shorttermcourseregistration" element={<ShortTermCourseRegistration />} />
        <Route path="/courseregistration" element={<CourseRegistration />} />
        <Route path="/newsandevents" element={<NewsAndEvents />} />
        <Route path="/worldsightday23" element={<WorldSightDayOld />} />
        <Route path="/worldsightday24" element={<WorldSightDay />} />
        <Route path="/christmasgettogether" element={<ChristmasGetTogether />} />
        <Route path="/awurudu" element={<Awurudu />} />
        <Route path="/annualmeeting" element={<AnnualMeeting />} />
        <Route path="/cricket" element={<Cricket />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/findyouroptometrist" element={<FindYourOptomerist />} />
        <Route path="/download" element={<Download />} />
        <Route path="/eyecarecareer" element={<EyecareCareer />} />
        <Route path="/careerapply/:id" element={<CareerApply />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/careerguidance25" element={<CareerGuidance />} />
        <Route path="/higherdiplomainoptometry" element={<HigherDiplomaInOptometry />} />
         <Route path="/ophthalmicoptician" element={<OphthalmicOptician />} />
        <Route path='/ourcourses' element={<Ourcourses />} />

        

        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path='/viewapplication' element={<ViewApplication />} />
        <Route path='/viewpayment' element={<ViewPayment />} />

        <Route path="/registration-course" element={<Test />} />
        <Route path="/orientation-Programme-2025" element={<OrientationProgramme />} />
        <Route path='/worldsightday25' element={<WorldSightDay25 />} />


        <Route
          path="/userprofile"
          element={
            <PrivateRoute>
                <UserProfile />
            </PrivateRoute>
          }
        />

                    
                     
        
                <Route
          path="/adminpanel"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />


                <Route
          path="/sub-adminpanel"
          element={
            <PrivateRoute>
              <SubAdminPanel />
            </PrivateRoute>
          }
        />


                <Route
          path="/accountpanel"
          element={
            <PrivateRoute>
              <Account />
            </PrivateRoute>
          }
        />


      </Routes>
    
      <FooterComp /> 
        {/* <Popup /> */}
      <DigitalLibrary />
      {/* <AwuruduSeason /> */}
      {/* <Snow /> */}
    </Router>
  );
};
